import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/dblift_logo.png';

const Hero = () => {
  const { t } = useTranslation();
  
  return (
    <section className="bg-gradient-to-br from-white to-dblift-gray-light">
      <div className="container py-20 md:py-32">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-12 md:mb-0">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <h1 className="text-5xl md:text-6xl font-bold text-dblift-blue-dark mb-6">
                {t('hero.title')} <span className="text-dblift-orange">like a pro</span>
              </h1>
              <p className="text-xl mb-8 text-dblift-gray-dark">
                {t('hero.description')}
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/download" className="btn btn-primary">
                  {t('hero.downloadBtn')}
                </Link>
                <Link to="/getting-started" className="btn btn-secondary">
                  {t('hero.startBtn')}
                </Link>
                <Link to="/docs" className="btn btn-outline">
                  {t('hero.docsBtn')}
                </Link>
              </div>
              <div className="mt-8 grid grid-cols-3 gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-dblift-blue-dark">3+</div>
                  <div className="text-sm text-dblift-gray-dark">{t('hero.stats.databases')}</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-dblift-blue-dark">100%</div>
                  <div className="text-sm text-dblift-gray-dark">{t('hero.stats.compatibility')}</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-dblift-blue-dark">7+</div>
                  <div className="text-sm text-dblift-gray-dark">{t('hero.stats.commands')}</div>
                </div>
              </div>
            </motion.div>
          </div>
          <div className="md:w-1/2 flex justify-center items-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="w-4/5"
            >
              <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 4, repeat: Infinity, repeatType: "reverse" }}
              >
                <img 
                  src={logo} 
                  alt="DBLift Logo" 
                  className="w-full drop-shadow-2xl"
                />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;